import React from "react";
import Registration from "../containers/Registration";
import NoNavLayout from "../layouts/NoNavLayout";

const RegistrationPage = props => {
  document.title = props.title;
  return (
    <NoNavLayout>
      <Registration />
    </NoNavLayout>
  );
};

export default RegistrationPage;






// WEBPACK FOOTER //
// ./src/pages/RegistrationPage.js